import MMLCCaseStudy from "./MMLCCaseStudy";

export { Page }

function Page() {
  return <MMLCCaseStudy />;
}
